import { useField } from 'formik';
import { AssistantChatKind } from 'shared/domains/apollo/generated/types';
import { ApprovalWorkflowInput } from './ApprovalWorkflowInput';
import { RegularInput } from './RegularInput';
import { TabularInput } from './TabularInput';
export function ContentField() {
    const [field] = useField('kind');
    const { value } = field;
    if (value === AssistantChatKind.Tabular) {
        return <TabularInput />;
    }
    if (value === AssistantChatKind.ApprovalWorkflow) {
        return <ApprovalWorkflowInput />;
    }
    return <RegularInput />;
}
